import React from 'react';
import CtaButton from './CtaButton';

function PricingSection() {
  return (
    <section className="pricing section">
      <div className="shell pricing-card">
        <div className="price-copy">
          <p className="eyebrow">One price. The full toolkit.</p>
          <h2>$69 <span>once</span></h2>
          <p className="no-subscription">No subscription. No required upsell.</p>
          <p className="price-anchor">
            One hour with a leadership coach runs $150–400. A two-day
            management course runs around $900. This costs less than either
            and lasts a career.
          </p>
        </div>
        <div className="price-action">
          <CtaButton>Get all 7 files</CtaButton>
          <small>Secure checkout through Gumroad</small>
        </div>
      </div>
    </section>
  );
}

export default PricingSection;